// @flow
import React from 'react';

import { StaticTable } from '../presentational/StaticTable';

export const ConnectTierPricingTable = () => {
  const tableContents = {
    headerRow: ['Tier Name', 'Tasks consumed', 'Task-hrs per month', 'Effective discount'],
    dataRows: [
      ['First 5 tasks', '5', '3650', '0%'],
      ['Next 6 - 25', '20', '14600', '10%'],
      ['Next 26 - 100', '75', '54750', '20%'],
      ['Next 101-500', '50', '36500', '40%'],
      ['Next 501-1,000', '500', '365000', '60%'],
      ['Next 1,000+', '', '', '80%'],
    ],
  };
  return <StaticTable tableContents={tableContents} />;
};
